import {
  Box,
  Button,
  FormControlLabel,
  Grid,
  Paper,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import withStyles from '@mui/styles/withStyles';
import { useState } from 'react';
import propTypes from 'prop-types';
import moment from 'moment';
import { capitalize, isEmpty, isUndefined, last } from 'lodash';
import Switch from '@mui/material/Switch';
import { useDispatch, useSelector } from 'react-redux';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LanguageIcon from '@mui/icons-material/Language';
import { useFirebase, useFirestore } from 'react-redux-firebase';
import collections from '../../../constants/FirestoreCollections';
import StatusHistoryPopup from '../../../shared/Popups/StatusHistoryPopup';
import StoppedHistoryPopup from '../../../shared/Popups/StoppedHistoryPopup';
import { CARRODILLA } from '../../../constants/organizations';
import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material';
import TemplatesPopup from '../../../shared/Popups/TemplatesPopup';
import { actions } from '../../../actions';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { handleResetContext } from '../helpers';
import { handleErrorSwal } from '../../../shared/swals';
const MySwal = withReactContent(Swal);

const useStyles = (small, openHeader) => {
  return makeStyles((theme) => ({
    infoPopup: {
      position: 'fixed',
      top: 0,
      zIndex: 2,
      width: '100%',
      height: 'calc(100dvh - 56px)',
      marginTop: '56px',
      background: theme.palette.white.main,
    },
    nameContainer: {
      alignSelf: small ? 'flex-start' : '',
    },
    name: {
      fontSize: '1.10rem',
      margin: '8px 0',
      marginBottom: small && 0,
    },
    chatSuperText: {
      fontSize: '0.8em',
      color: '#7a7a7a',
    },
    optionsContainer: {
      display: 'flex',
      justifyContent: small ? 'flex-start' : 'flex-end',
      alignItems: 'center',
      overflowX: 'auto',
    },
    smallButton: {
      minWidth: 'max-content',
      borderRadius: '3px',
      paddingBlock: 1,
      paddingInline: 8,
      backgroundColor: '#9C27B0',
      color: theme.palette.white.main,
      '&:hover': {
        backgroundColor: '#b834cf',
      },
      fontSize: theme.sizes.sm.t1,
    },
    userMode: {
      // position: !small && 'absolute',
      // top: '56px',
      // right: '360px',
      margin: 0,
      marginRight: '8px',
      minWidth: 'max-content',
    },
    autoStopBot: {
      minWidth: 'max-content',
      position: !small && 'absolute',
      top: '56px',
      right: '160px',
      margin: 0,
      marginRight: '8px',
    },
    reanudarBot: {
      position: !small && 'absolute',
      top: '56px',
      right: '20px',
      margin: 0,
      marginRight: 0,
    },
    header: {
      // display: !openHeader && 'none',
      position: 'absolute',
      zIndex: 2,
      top: 0,
    },
    paper: {
      position: 'relative',
      height: small ? '130px' : '140px',
      boxShadow: '0 .125rem .25rem rgba(0,0,0,.075)!important',
    },
    paperSmall: {
      height: '50px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      overflowY: 'auto',
    },
    closeHeader: {
      position: 'absolute',
      left: 'calc(50% - 20px)',
      bottom: 8,
      zIndex: 4,
      '&:hover': {
        opacity: '.7',
      },
      cursor: 'pointer',
    },
    closeInfo: {
      cursor: 'pointer',
      '&:hover': {
        opacity: '.7',
      },
    },
    chatButtons: {
      display: small ? 'none' : 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      position: 'absolute',
      right: '16px',
      bottom: 0,
    },
    chips: {
      textAlign: 'center',
      width: 'fit-content',
      minWidth: small ? '120px' : '100px',
      borderRadius: '3rem',
      cursor: 'default',
      paddingInline: 4,
      color: 'white',
    },
    switchLabel: {
      fontSize: 13,
    },
  }));
};

const PurpleSwitch = withStyles({
  switchBase: {
    color: '#F18848',
    '&$checked': {
      color: '#EC453F',
    },
    '&$checked + $track': {
      backgroundColor: '#EC453F',
    },
  },
  checked: {},
  track: {},
})(Switch);

const getChatType = (chat) => {
  return chat.type === 1 ? (
    <WhatsAppIcon style={{ fontSize: 16, color: 'green', marginRight: '5px' }} />
  ) : (
    <LanguageIcon style={{ fontSize: 16, color: 'blue', marginRight: '5px' }} />
  );
};

const getName = (chat) => {
  let client = '';
  if (!isUndefined(chat.client)) {
    if (!isEmpty(chat.client.name)) {
      client = `${chat.client.name} `;
    }
    if (!isEmpty(chat.client.phone)) {
      client += `${client ? '- ' : ''}${chat.client.phone}`;
    }
  }
  return client;
};

function Info(props) {
  const {
    chat,
    userMode,
    setUserMode,
    isOlderChat,
    autoStop,
    openHeader,
    setOpenHeader,
    setAutoStop,
  } = props;

  // define styles
  const small = useMediaQuery('(max-width:600px)');
  // eslint-disable-next-line no-unused-vars
  const classes = useStyles(small, openHeader)();
  const projectId = process.env.REACT_APP_PROJECT_ID;
  const config = useSelector((state) => state.app.prestobotsConfig);

  // redux
  const infoChat = useSelector((state) => state.app.infoChat);
  const profile = useSelector((state) => state.firebase.profile);
  const chatId = useSelector((state) => state.app.activeChat);

  // hooks
  const organization = useSelector((state) => state.app.organization);
  const firestore = useFirestore();
  const firebase = useFirebase();
  const appDispatch = useDispatch();
  // states
  const [openTemplatesPopup, setOpenTemplatesPopup] = useState(false);
  const [openStoppedPopup, setOpenStoppedPopup] = useState(false);
  const [openStatusPopup, setOpenStatusPopup] = useState(false);

  // custom cases
  const isCarrodilla = CARRODILLA.includes(organization.id);

  const historyStopped =
    chat && chat.stoppedHistory && chat.stoppedHistory.length > 0 ? chat.stoppedHistory : [];

  const isAdmin = profile?.claims?.includes('admin');
  const isDisablePanelUserMessaging =
    organization?.businessRules?.disablePanelUserMessaging && !isAdmin;
  const statusInfo = config && config.states && config.states.find((e) => e.key === chat.status);

  // methods

  const handleOpenChat = () => {
    window.open(
      `https://console.firebase.google.com/u/0/project/${projectId}/firestore/data/~2Fchats/${chatId}`,
    );
  };

  const handleCopyID = () => {
    navigator.clipboard.writeText(chat.session);
    appDispatch({
      type: actions.alert,
      alert: {
        snackbarOpen: true,
        snackbarMessage: `ID copiado en portapapeles`,
        snackbarSeverity: 'info',
      },
    });
  };

  const handleSetFinish = async () => {
    if (isDisablePanelUserMessaging) return;
    const newStatus = {
      creationDate: firestore.Timestamp.fromDate(new Date()),
      status: 3,
      user: profile.email,
    };

    firestore
      .collection(collections.chats)
      .doc(chatId)
      .update({
        statusHistory: firestore.FieldValue.arrayUnion(newStatus),
        status: 3,
        botStopped: false,
      });
    // TODO: await updateChatSupportAndAssignment({ chatId, chat }); Contabilizar chat cuanto este se finaliza
  };

  const handleSetTraining = () => {
    if (isDisablePanelUserMessaging) return;
    firestore
      .collection(collections.chats)
      .doc(chatId)
      .update({
        training: !chat.training,
        trainingTime: [],
        timesInRow: 0,
        botStopped: false,
      })
      .catch(() => {
        // TODO
      });
  };

  const handleSetBotStopped = (ev) => {
    if (isDisablePanelUserMessaging) return;
    const updates = {
      botStopped: ev.target.checked,
    };
    if (ev.target.checked)
      updates.stoppedHistory = firestore.FieldValue.arrayUnion({
        user: profile.email,
        date: new Date(Date.now()),
      });

    firestore
      .collection(collections.chats)
      .doc(chatId)
      .update(updates)
      .catch(() => {
        // TODO
      });
  };
  const includesActiveTemplate = () => {
    return organization?.templates?.some(
      (e) => e.isActive && Array.isArray(e.params) && e.params.length === 0,
    );
  };

  const handleSetAutoStop = (ev) => {
    if (isDisablePanelUserMessaging) return;
    setAutoStop(ev.target.checked);
  };

  const onResetContext = async (e) => {
    try {
      if (isDisablePanelUserMessaging) return;
      e && e.preventDefault();
      const token = await generateToken();
      const infoRoute = '/chat-context';
      const sessionId = chat.session.split('/').pop();
      const providerId = organization.provider.dfId;
      const result = await handleResetSwal();

      if (result.isConfirmed) {
        appDispatch({
          type: actions.changeLoading,
          loading: { loading: true, priority: 1 },
        });
        const { data } = await handleResetContext({
          token,
          chatId,
          infoRoute,
          projectId: providerId,
          sessionId,
        });
        return handleSuccesSwal(data);
      }
    } catch (error) {
      return handleErrorSwal(error.response.data);
    } finally {
      appDispatch({
        type: actions.changeLoading,
        loading: { loading: false, priority: 1 },
      });
    }
  };
  const handleResetSwal = async () => {
    return MySwal.fire({
      text: '¿Está seguro que desea RESETEAR los contextos?',
      confirmButtonText: 'Sí',
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonColor: '#d33',
      icon: 'warning',
      customClass: {
        container: 'gap: 100px',
      },
    });
  };
  const handleSuccesSwal = async (message) => {
    return MySwal.fire({
      title: 'Contextos Reseteados',
      text: message,
      icon: 'success',
      confirmButtonText: 'OK',
    });
  };
  const generateToken = async () => {
    try {
      const token = await firebase.auth().currentUser.getIdToken(true);
      return token;
    } catch (error) {
      console.log('error en generateToken, MessageContainer', error);
    }
  };

  return (
    <Box>
      {openStoppedPopup && (
        <StoppedHistoryPopup
          handleClose={() => setOpenStoppedPopup(false)}
          history={historyStopped}
        />
      )}
      {openStatusPopup && (
        <StatusHistoryPopup
          handleClose={() => setOpenStatusPopup(false)}
          chat={chat}
          chatId={chatId}
        />
      )}
      {infoChat && (
        <Box className={classes.infoPopup} p={2}>
          <Typography className={classes.name} variant="h6">
            {getChatType(chat)}
            {getName(chat)}
          </Typography>
          <Typography variant="subtitle1" className={classes.chatSuperText}>
            UIC: {moment(chat.creationDate.toDate()).fromNow()} |{' '}
            {moment(chat.creationDate.toDate()).format('LLLL')}
          </Typography>
          <Typography variant="subtitle1" className={classes.chatSuperText}>
            Último mensaje: {moment(last(chat.messages).creationDate.toDate()).fromNow()}{' '}
            {moment(last(chat.messages).creationDate.toDate()).format('LLLL')}
          </Typography>
          {isAdmin && (
            <Box my={1} marginX="4px">
              <Button variant="contained" className={classes.smallButton} onClick={handleOpenChat}>
                Abrir chat
              </Button>
            </Box>
          )}
          <Box my={1} marginX="4px">
            <Button variant="contained" className={classes.smallButton} onClick={handleCopyID}>
              Copiar session
            </Button>
          </Box>
          {!isDisablePanelUserMessaging && (
            <>
              <Box my={1} marginX="4px">
                <Button
                  variant="contained"
                  className={classes.smallButton}
                  onClick={() => {
                    setOpenStoppedPopup(true);
                  }}
                >
                  Detenciones
                </Button>
              </Box>
              <Box my={1} marginX="4px">
                <Button
                  variant="contained"
                  className={classes.smallButton}
                  onClick={() => {
                    setOpenStatusPopup(true);
                  }}
                >
                  Estados
                </Button>
              </Box>
              {organization &&
                organization.provider &&
                organization.provider.name === 'gupshup' &&
                chat.type === 1 &&
                includesActiveTemplate() && (
                  <Box marginX="4px" my={1}>
                    <Button
                      className={classes.smallButton}
                      variant="contained"
                      color="primary"
                      onClick={() => setOpenTemplatesPopup(true)}
                    >
                      Enviar plantillas
                    </Button>
                  </Box>
                )}
              {isAdmin && !chat.training && (
                <Box marginX="4px" my={1}>
                  <Button
                    variant="contained"
                    className={classes.smallButton}
                    onClick={handleSetTraining}
                  >
                    Revisar
                  </Button>
                </Box>
              )}
              {isAdmin && chat.training && (
                <Box marginX="4px" my={1}>
                  <Button
                    variant="contained"
                    className={classes.smallButton}
                    onClick={handleSetTraining}
                  >
                    Finalizar revision
                  </Button>
                </Box>
              )}
              {chat.status !== 3 && (
                <Box mx="4px" my={1}>
                  <Button
                    variant="contained"
                    className={classes.smallButton}
                    onClick={async () => handleSetFinish()}
                  >
                    Finalizar
                  </Button>
                </Box>
              )}
              <Box marginX="4px">
                <Button
                  className={classes.smallButton}
                  variant="contained"
                  color="primary"
                  onClick={onResetContext}
                >
                  Resetear Contexto
                </Button>
              </Box>
            </>
          )}
          {!isDisablePanelUserMessaging && (
            <Box display="flex" flexDirection="column">
              <FormControlLabel
                disabled={isOlderChat && !isCarrodilla}
                control={
                  <PurpleSwitch
                    checked={userMode}
                    onChange={() => setUserMode(!userMode)}
                    name="sendInPacientMode"
                  />
                }
                label="Enviar como paciente"
                className={classes.userMode}
              />
              <FormControlLabel
                disabled={isOlderChat && !isCarrodilla}
                control={
                  <PurpleSwitch
                    checked={autoStop}
                    onChange={handleSetAutoStop}
                    name="detenerAlEnviar"
                  />
                }
                label={autoStop ? 'Detener al enviar' : 'No detener al enviar'}
                className={classes.autoStopBot}
              />
              <FormControlLabel
                disabled={isOlderChat && !isCarrodilla}
                control={
                  <PurpleSwitch
                    checked={chat.botStopped}
                    onChange={handleSetBotStopped}
                    name="checkedA"
                  />
                }
                label={chat.botStopped ? 'Bot Detenido' : 'Detener Bot'}
                className={classes.reanudarBot}
              />
            </Box>
          )}
        </Box>
      )}
      {!infoChat && !openHeader && (
        <Grid className={classes.header} container spacing={0}>
          <Grid item xs={12}>
            <Paper className={classes.paperSmall} square xs={12}>
              <Box display="flex" px={2} className={classes.nameContainer}>
                <Typography className={classes.name} variant="h6">
                  {getChatType(chat)}
                  {getName(chat)}
                </Typography>
              </Box>
              <Box display="flex" alignItems="center" mr={2}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  className={classes.chips}
                  sx={{
                    backgroundColor: (statusInfo && statusInfo.color) || '#ffcc01',
                  }}
                >
                  {statusInfo ? capitalize(statusInfo.label) : ''}
                </Box>
                <Box ml={2} className={classes.closeInfo} onClick={() => setOpenHeader(true)}>
                  <ArrowDropDown />
                </Box>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      )}
      {!infoChat && openHeader && (
        <Grid className={classes.header} container spacing={0}>
          <Grid item xs={12}>
            <Paper className={classes.paper} square xs={12}>
              <Grid item xs={12}>
                <Box className={classes.optionsContainer} pt="4px" px={2}>
                  {isAdmin && (
                    <Box marginX="4px">
                      <Button
                        className={classes.smallButton}
                        variant="contained"
                        color="primary"
                        onClick={handleOpenChat}
                      >
                        Abrir chat
                      </Button>
                    </Box>
                  )}
                  <Box marginX="4px">
                    <Button
                      className={classes.smallButton}
                      variant="contained"
                      color="primary"
                      onClick={handleCopyID}
                    >
                      Copiar session
                    </Button>
                  </Box>
                  {!isDisablePanelUserMessaging && (
                    <>
                      <Box marginX="4px">
                        <Button
                          variant="contained"
                          className={classes.smallButton}
                          onClick={() => {
                            setOpenStoppedPopup(true);
                          }}
                        >
                          Detenciones
                        </Button>
                      </Box>
                      <Box marginX="4px">
                        <Button
                          variant="contained"
                          className={classes.smallButton}
                          onClick={() => {
                            setOpenStatusPopup(true);
                          }}
                        >
                          Estados
                        </Button>
                      </Box>
                      {organization &&
                        organization.provider &&
                        organization.provider.name === 'gupshup' &&
                        chat.type === 1 &&
                        includesActiveTemplate() && (
                          <Box marginX="4px">
                            <Button
                              className={classes.smallButton}
                              variant="contained"
                              color="primary"
                              onClick={() => setOpenTemplatesPopup(true)}
                            >
                              Enviar plantillas
                            </Button>
                          </Box>
                        )}
                      {isAdmin && !chat.training && (
                        <Box marginX="4px">
                          <Button
                            variant="contained"
                            className={classes.smallButton}
                            onClick={handleSetTraining}
                          >
                            Revisar
                          </Button>
                        </Box>
                      )}
                      {isAdmin && chat.training && (
                        <Box marginX="4px">
                          <Button
                            variant="contained"
                            className={classes.smallButton}
                            onClick={handleSetTraining}
                          >
                            Finalizar revision
                          </Button>
                        </Box>
                      )}
                      {chat.status !== 3 && (
                        <Box marginX="4px">
                          <Button
                            variant="contained"
                            className={classes.smallButton}
                            onClick={async () => handleSetFinish()}
                          >
                            Finalizar
                          </Button>
                        </Box>
                      )}
                      <Box marginX="4px">
                        <Button
                          className={classes.smallButton}
                          variant="contained"
                          color="primary"
                          onClick={onResetContext}
                        >
                          Resetear Contexto
                        </Button>
                      </Box>
                    </>
                  )}
                </Box>
              </Grid>
              <Grid>
                <Box pb={0} pl={2}>
                  <Typography className={classes.name} variant="h6">
                    {getChatType(chat)}
                    {getName(chat)}
                  </Typography>
                  {!small && (
                    <Typography variant="subtitle1" className={classes.chatSuperText}>
                      UIC: {moment(chat.creationDate.toDate()).fromNow()} |{' '}
                      {moment(chat.creationDate.toDate()).format('LLLL')}
                    </Typography>
                  )}
                  {!small && (
                    <Typography variant="subtitle1" className={classes.chatSuperText}>
                      Último mensaje:{' '}
                      {chat.messages.length > 0 &&
                        moment(last(chat.messages).creationDate.toDate()).fromNow()}{' '}
                      {chat.messages.length > 0 &&
                        moment(last(chat.messages).creationDate.toDate()).format('LLLL')}
                    </Typography>
                  )}
                  {!small && chat.assigned && (
                    <Typography variant="subtitle1" className={classes.chatSuperText}>
                      Asignado a: {chat.assigned}
                    </Typography>
                  )}
                </Box>
                <Box className={classes.closeHeader} onClick={() => setOpenHeader(false)}>
                  <ArrowDropUp />
                </Box>
              </Grid>
              {!isDisablePanelUserMessaging && (
                <Box className={classes.chatButtons}>
                  <Box display="flex" pt={1} height="100px">
                    <FormControlLabel
                      disabled={isOlderChat && !isCarrodilla}
                      control={
                        <PurpleSwitch
                          checked={userMode}
                          onChange={() => setUserMode(!userMode)}
                          name="sendInPacientMode"
                        />
                      }
                      label={
                        <Typography className={classes.switchLabel}>
                          Enviar como paciente
                        </Typography>
                      }
                      className={classes.userMode}
                    />
                    <FormControlLabel
                      disabled={isOlderChat && !isCarrodilla}
                      control={
                        <PurpleSwitch
                          checked={autoStop}
                          onChange={handleSetAutoStop}
                          name="detenerAlEnviar"
                        />
                      }
                      label={
                        <Typography className={classes.switchLabel}>
                          {autoStop ? 'Detener al enviar' : 'No detener al enviar'}
                        </Typography>
                      }
                      className={classes.autoStopBot}
                    />
                    <FormControlLabel
                      disabled={isOlderChat && !isCarrodilla}
                      control={
                        <PurpleSwitch
                          checked={chat.botStopped}
                          onChange={handleSetBotStopped}
                          name="checkedA"
                        />
                      }
                      label={
                        <Typography className={classes.switchLabel}>
                          {chat.botStopped ? 'Bot Detenido' : 'Detener Bot'}
                        </Typography>
                      }
                      className={classes.reanudarBot}
                    />
                  </Box>
                </Box>
              )}
            </Paper>
          </Grid>
        </Grid>
      )}

      <TemplatesPopup open={openTemplatesPopup} handleClose={() => setOpenTemplatesPopup(false)} />
    </Box>
  );
}

const Props = {
  chat: propTypes.object,
  userMode: propTypes.bool,
  setUserMode: propTypes.func,
  isOlderChat: propTypes.bool,
  autoStop: propTypes.bool,
  setOpenHeader: propTypes.func,
  setAutoStop: propTypes.func,
  openHeader: propTypes.bool,
};

Info.propTypes = Props;

export default Info;
